import React, { useEffect, useRef, useState } from 'react'
import NewsItem from './NewsItem'
import Spinner from './Spinner';
import PropTypes from 'prop-types'
import InfiniteScroll from "react-infinite-scroll-component";


export default function News (props){

  
  const [articles,setArticles] = useState([])
  const [page,setPage] = useState(1)
  const [totalResults,setTotalResults] = useState(0)
  const [loading,setLoading] = useState(true)
  const [data, setData] = useState(true);
  const prevCategoryRef = useRef(props.category)  //This line will be executed only once

  const updateNews = async () => {

    props.setProgress(10)
    let data = await fetch(`https://newsapi.org/v2/top-headlines?country=${props.country}&category=${props.category}&apiKey=${props.apiKey}&page=1&pageSize=${props.pageSize}`)
    setLoading(true)
  
    let parsedData = await data.json();
    props.setProgress(40)

    setArticles(parsedData.articles)
    setTotalResults(parsedData.totalResults)
    setData(true)
    setLoading(false)
    props.setProgress(100)

  }

  useEffect( () => {

     updateNews()

  }, []);

//when props.category changes it runs
  useEffect( () => {
  
  //1.When value chnaged it doesnot trigger re - render
  //2.Initialized only once during first render**

    document.title = props.category.charAt(0).toUpperCase() + props.category.slice(1)
    if(prevCategoryRef.current !== props.category){
  
      setPage(1)
      updateNews()

     }

    prevCategoryRef.current = props.category

    
  }, [props.category]);





  const fetchMoreData = async () => {

    
    let parsedData;

    if(page < Math.ceil(totalResults / props.pageSize)){

    let pageNumber = page+1; 
    let data = await fetch(`https://newsapi.org/v2/top-headlines?country=${props.country}&category=${props.category}&apiKey=${props.apiKey}&page=${pageNumber}&pageSize=${props.pageSize}`)
    parsedData = await data.json();

    setArticles(articles.concat(parsedData.articles))
    setPage(pageNumber)
    
    }
    else{
      setData(false)
    }

  } 
  
    return (

        <>
        <h3 className='text-center' style={{marginTop: '90px'}}>TOP {props.category.toUpperCase()} HEADLINES</h3>  
        {loading && <Spinner />}
        <InfiniteScroll style={{overflow: "visible"}}
          dataLength={articles.length}
          next={fetchMoreData}
          hasMore={articles.length !== totalResults && data}
          loader={<Spinner />}
          >
                  <div className='container my-5' >
                  <div className='row'>
                        { 
                        articles.map((element) => { return <div className='col-md-4' key={element.url}><NewsItem  title={element.title === null ? "": element.title} description={element.description === null ? "":element.description} urlToImage={element.urlToImage} url= {element.url}  source={element.source.name === null ? "": element.source.name} publishedAt={element.publishedAt === null ? "": element.publishedAt}  /></div>})
                        }
                  </div>
                  </div>
    
        </InfiniteScroll> 
        </>
    
    )
  
}



News.defaultProps = {

    country: "us",
    pageSize: 6,
    category: "sports"
    
  }

News.propTypes = {

    country: PropTypes.string,
    pageSize: PropTypes.number,
    category: PropTypes.string    
  }
  
